package horcrux.frontend.common.views.components.containers

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.views.collections.CollectionNavigator
import react.FC
import react.PropsWithChildren

external interface ViewWithCollectionNavigatorProps : PropsWithChildren {
    var globalAppState: GlobalAppState
}

val ViewWithCollectionNavigator = FC<ViewWithCollectionNavigatorProps> { props ->
    val collectionNavigatorProps = props.globalAppState.getCollectionNavigatorProps()
    collectionNavigatorProps.globalAppState.createPopulateDocumentMetadataListEffect()

    if (props.globalAppState.currentCollectionMetadataMaybeState.get() == null) {
        props.globalAppState.shouldShowCollectionNavigatorState.setTrue()
    }
    CollectionNavigator { +collectionNavigatorProps }
    +props.children
}
